import { useCallback, useEffect, useState } from 'react';
import { Wallet } from 'lucide-react';
import { API, EmptyBox, ErrorBox, LoadingBox, TabHeader, asList, fmtCell, labelFor } from './AdminShared';

export const AdminFinance = ({ authHeaders, tx }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await fetch(`${API}/api/admin/app-finance?limit=50`, { headers: authHeaders() });
      if (!res.ok) throw new Error('finance');
      setItems(asList(await res.json(), ['purchases', 'items', 'transactions', 'records']));
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [authHeaders]);

  useEffect(() => {
    load();
  }, [load]);

  const columns = items.length > 0 ? Object.keys(items[0]).slice(0, 6) : [];

  return (
    <section data-testid="app-finance-section">
      <TabHeader icon={Wallet} title={tx.finance.title} count={items.length} onRefresh={load} refreshLabel={tx.common.refresh} testid="app-finance" />

      <div className="mt-6">
        {loading && <LoadingBox text={tx.common.loading} testid="app-finance-loading" />}
        {!loading && error && (
          <ErrorBox text={tx.common.unavailable} retryText={tx.common.retry} onRetry={load} testid="app-finance-error" />
        )}
        {!loading && !error && items.length === 0 && <EmptyBox text={tx.finance.empty} testid="app-finance-empty" />}
        {!loading && !error && items.length > 0 && (
          <div className="overflow-x-auto rounded-2xl border border-white/10">
            <table data-testid="app-finance-table" className="w-full text-left text-sm">
              <thead>
                <tr className="bg-white/[0.04] text-xs uppercase tracking-wider text-slate-500">
                  {columns.map((c) => (
                    <th key={c} className="px-5 py-3.5 font-bold">
                      {labelFor(c, tx.fields)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((item, i) => (
                  <tr key={item.id || item.purchase_id || i} className="border-t border-white/5 hover:bg-white/[0.03] transition-colors duration-200">
                    {columns.map((c) => (
                      <td key={c} className="px-5 py-3.5 text-slate-300">
                        {fmtCell(c, item[c])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default AdminFinance;
